import React, { SVGProps } from "react";

export default function SupLove(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.35561 9.63793C3.31781 11.879 9.99672 16.5 9.99672 16.5C9.99672 16.5 16.6822 11.873 17.6444 9.63192C18.6066 7.39082 17.549 4.80287 15.2822 3.85158C13.3683 3.04836 11.2042 3.66875 9.99767 5.23035C8.79025 3.67317 6.62929 3.0554 4.7178 3.85758C2.451 4.80887 1.39341 7.39682 2.35561 9.63793Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}
